// pages/pedidos/ModalHorarios.js
import React, { useState, useEffect } from 'react';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import './ModalHorarios.css';
import { useHorario } from '../../contexts/pedidos/HorarioContext';
import { useHorarioExcecao } from '../../contexts/pedidos/HorarioExcecaoContext';
import { HorarioExcecao } from '../../models/pedidos/HorarioExcecao';
import { useYesNo } from '../../contexts/geral/YesNoContext';

const diasSemana = [
  { label: "D", nome: "Domingo" },
  { label: "S", nome: "Segunda" },
  { label: "T", nome: "Terça" },
  { label: "Q", nome: "Quarta" },
  { label: "Q", nome: "Quinta" },
  { label: "S", nome: "Sexta" },
  { label: "S", nome: "Sábado" }
];

const ModalHorarios = ({ show, onClose }) => {

  const { showYesNo } = useYesNo();

  const { horarios: horariosBanco, salvarHorarios } = useHorario();

  const [activeTab, setActiveTab] = useState("funcionamento");
  const [diasSelecionados, setDiasSelecionados] = useState([]);
  const [horarios, setHorarios] = useState({});

  const [erros, setErros] = useState({});
  const [erroDias, setErroDias] = useState(false);

  //Exceções
  const { excecaoNaoFinalizadas, fetchExcecaoAtiva, fetchExcecaoNaoFinalizadas, insertExcecao, updateExcecao, deleteExcecao } = useHorarioExcecao();
  const [modoEdicaoExcecao, setModoEdicaoExcecao] = useState(false);
  const [editando, setEditando] = useState(false);
  const [formExcecao, setFormExcecao] = useState(new HorarioExcecao());

  const abrirNovaExcecao = () => {
    setEditando(false);
    setFormExcecao(new HorarioExcecao());
    setModoEdicaoExcecao(true);
  };


  const editarExcecao = (excecaoApi) => {
    setFormExcecao(excecaoApi);
    setEditando(true);
    setModoEdicaoExcecao(true);
  };

  const excluirExcecao = async (excecao) => {

    const resposta = await showYesNo(
        "Deseja excluir a exceção selecionada?"
    );

    if (!resposta) return;

    await deleteExcecao(excecao.id);
  };



  const salvarExcecao = () => {

    if (editando) {
      updateExcecao(formExcecao);
    } else {
      insertExcecao(formExcecao);
    }

    setModoEdicaoExcecao(false);
  };

  useEffect(() => {
    if (!show) return;

    fetchExcecaoAtiva();
    fetchExcecaoNaoFinalizadas();

  }, [show]);

  useEffect(() => {
    if (!show) return;

    const horariosValidos = Array.isArray(horariosBanco) ? horariosBanco : [];

    if (horariosValidos.length > 0) {

      const dias = [];
      const estrutura = {};

      horariosValidos.forEach(item => {
        dias.push(item.diaSemana);

        estrutura[item.diaSemana] = item.periodos.map(p => ({
          abertura: p.horaAbertura?.substring(0, 5),
          fechamento: p.horaFechamento?.substring(0, 5)
        }));
      });

      setDiasSelecionados(dias);
      setHorarios(estrutura);

    } else {
      setDiasSelecionados([]);
      setHorarios({});
    }

  }, [show, horariosBanco]);

  const toggleDia = (index) => {

    if (diasSelecionados.includes(index)) {

      const novosDias = diasSelecionados.filter(d => d !== index);
      setDiasSelecionados(novosDias);

      const copia = { ...horarios };
      delete copia[index];
      setHorarios(copia);

    } else {

      setDiasSelecionados([...diasSelecionados, index]);
      setHorarios({
        ...horarios,
        [index]: [{ abertura: "", fechamento: "" }]
      });

    }
  };

  const alterarHorario = (diaIndex, periodoIndex, campo, valor) => {
    const copia = { ...horarios };
    copia[diaIndex][periodoIndex][campo] = valor;
    setHorarios(copia);

    // Remove erro específico ao corrigir
    const chave = `${diaIndex}-${periodoIndex}-${campo}`;
    const chaveIntervalo = `${diaIndex}-${periodoIndex}-intervalo`;

    setErros(prev => {
      const novos = { ...prev };
      delete novos[chave];
      delete novos[chaveIntervalo];
      return novos;
    });
  };


  const adicionarPeriodo = (diaIndex) => {
    const copia = { ...horarios };
    copia[diaIndex].push({ abertura: "", fechamento: "" });
    setHorarios(copia);
  };

  const removerPeriodo = (diaIndex, periodoIndex) => {

    const copia = { ...horarios };

    // Se for o último período → desmarca o dia
    if (copia[diaIndex].length === 1) {

      const novosDias = diasSelecionados.filter(d => d !== diaIndex);
      setDiasSelecionados(novosDias);

      delete copia[diaIndex];
      setHorarios(copia);

      return;
    }

    copia[diaIndex].splice(periodoIndex, 1);
    setHorarios(copia);
  };


  const handleSalvar = () => {

    let novosErros = {};
    let possuiErro = false;

    // 🔴 Validação dias
    if (diasSelecionados.length === 0) {
      setErroDias(true);
      possuiErro = true;
    } else {
      setErroDias(false);
    }

    for (const diaIndex of diasSelecionados) {

      const periodos = horarios[diaIndex];

      if (!periodos || periodos.length === 0) {
        novosErros[`${diaIndex}-geral`] = "Adicione pelo menos um horário.";
        possuiErro = true;
        continue;
      }

      for (const [periodoIndex, periodo] of periodos.entries()) {

        if (!periodo.abertura) {
          novosErros[`${diaIndex}-${periodoIndex}-abertura`] = "Informe a abertura";
          possuiErro = true;
        }

        if (!periodo.fechamento) {
          novosErros[`${diaIndex}-${periodoIndex}-fechamento`] = "Informe o fechamento";
          possuiErro = true;
        }

        if (
          periodo.abertura &&
          periodo.fechamento &&
          periodo.abertura >= periodo.fechamento
        ) {
          novosErros[`${diaIndex}-${periodoIndex}-intervalo`] =
            "A abertura deve ser menor que o fechamento";
          possuiErro = true;
        }

      }
    }

    setErros(novosErros);

    if (possuiErro) return;

    // 🔵 Monta formato backend

    const formatoBackend = diasSelecionados.map(diaIndex => ({
      diaSemana: diaIndex,
      periodos: horarios[diaIndex].map(p => ({
        horaAbertura: p.abertura + ":00",
        horaFechamento: p.fechamento + ":00"
      }))
    }));

    salvarHorarios(formatoBackend);
    onClose();
  };

  return (
    <ModalContainer largura="750px" show={show}>
      <ModalHeader>

        <div className="tab-menu">
          <div
            className={`tab-item ${activeTab === "funcionamento" ? "active" : ""}`}
            onClick={() => setActiveTab("funcionamento")}
          >
            Horário de Funcionamento
          </div>

          <div
            className={`tab-item ${activeTab === "excecao" ? "active" : ""}`}
            onClick={() => setActiveTab("excecao")}
          >
            Horário Exceção
          </div>
        </div>

      </ModalHeader>

      <ModalBody>

        {activeTab === "funcionamento" && (
          <div className="modal-horarios-container">

            <div className={`label-dias ${erroDias ? "label-erro" : ""}`}>
              Dias da semana *
              {erroDias && (
                <span className="erro-texto-inline">
                  Selecione pelo menos um dia
                </span>
              )}
            </div>


            <div className="dias-semana-container">
              {diasSemana.map((dia, index) => (
                <div
                  key={index}
                  className={`dia-badge ${diasSelecionados.includes(index) ? "ativo" : ""}`}
                  onClick={() => toggleDia(index)}
                >
                  {dia.label}
                </div>
              ))}
            </div>

            <div className="horarios-detalhe">

              {diasSelecionados.map((diaIndex) => (
                <div key={diaIndex} className="dia-horario-bloco">

                  <div className="dia-nome">
                    {diasSemana[diaIndex].nome}:
                  </div>

                  <div className="periodos-container">

                    {horarios[diaIndex]?.map((periodo, periodoIndex) => (
                      <div key={periodoIndex} className="periodo-row">

                        {erros[`${diaIndex}-${periodoIndex}-intervalo`] && (
                          <div className="erro-texto">
                            {erros[`${diaIndex}-${periodoIndex}-intervalo`]}
                          </div>
                        )}


                        <input
                          type="time"
                          value={periodo.abertura}
                          className={erros[`${diaIndex}-${periodoIndex}-abertura`] ? "input-erro" : ""}
                          onChange={(e) =>
                            alterarHorario(diaIndex, periodoIndex, "abertura", e.target.value)
                          }
                        />

                        {erros[`${diaIndex}-${periodoIndex}-abertura`] && (
                          <div className="erro-texto">
                            {erros[`${diaIndex}-${periodoIndex}-abertura`]}
                          </div>
                        )}

                        <input
                          type="time"
                          value={periodo.fechamento}
                          className={erros[`${diaIndex}-${periodoIndex}-fechamento`] ? "input-erro" : ""}
                          onChange={(e) =>
                            alterarHorario(diaIndex, periodoIndex, "fechamento", e.target.value)
                          }
                        />

                        {erros[`${diaIndex}-${periodoIndex}-fechamento`] && (
                          <div className="erro-texto">
                            {erros[`${diaIndex}-${periodoIndex}-fechamento`]}
                          </div>
                        )}


                        <button
                          className="btn-remove-periodo"
                          onClick={() => removerPeriodo(diaIndex, periodoIndex)}
                        >
                          -
                        </button>

                      </div>
                    ))}

                    <button
                      className="btn-add-periodo"
                      onClick={() => adicionarPeriodo(diaIndex)}
                    >
                      +
                    </button>

                  </div>

                </div>
              ))}

            </div>

          </div>
        )}

        {activeTab === "excecao" && (
          <div className="modal-excecao-container">

            <div className="header-excecao">
              <button
                className="btn-incluir-excecao"
                onClick={abrirNovaExcecao}
              >
                + Incluir Exceção
              </button>
            </div>

            {/* GRID */}
            {excecaoNaoFinalizadas?.length > 0 && !modoEdicaoExcecao && (
              <div className="grid-excecao">

                <div className="grid-header">
                  <div>Tipo</div>
                  <div>Motivo</div>
                  <div>Início</div>
                  <div>Fim</div>
                  <div>Ações</div>
                </div>

                {excecaoNaoFinalizadas.map((excecao) => (
                  <div className="grid-row" key={excecao.id}>
                    <div>{HorarioExcecao.getDescricaoTipo(excecao.tipo)}</div>
                    <div>{excecao.motivo}</div>
                    <div>{new Date(excecao.dataHoraInicio).toLocaleString()}</div>
                    <div>{new Date(excecao.dataHoraFim).toLocaleString()}</div>
                    <div className="acoes-grid">
                      <button onClick={() => editarExcecao(excecao)}>✏️</button>
                      <button className="btn-excluir" onClick={() => excluirExcecao(excecao)}>🗑️</button>
                    </div>
                  </div>
                ))}

              </div>
            )}


            {/* FORM */}
            {modoEdicaoExcecao && (
              <div className="form-excecao">

                <div className="form-group">
                  <label>Tipo:</label>

                  <div className="radio-group">
                    {HorarioExcecao.TiposLista.map(tipo => (
                      <label key={tipo.value}>
                        <input
                          type="radio"
                          value={tipo.value}
                          checked={formExcecao.tipo === tipo.value}
                          onChange={() =>
                            setFormExcecao({ ...formExcecao, tipo: tipo.value })
                          }
                        />
                        {tipo.label}
                      </label>
                    ))}
                  </div>

                </div>

                <div className="form-group">
                  <label>Motivo:</label>
                  <textarea
                    rows={2}
                    value={formExcecao.motivo}
                    onChange={(e) =>
                      setFormExcecao({ ...formExcecao, motivo: e.target.value })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>Data Hora Inicial:</label>
                  <div className="data-hora-row">
                    <input
                      type="datetime-local"
                      value={formExcecao.dataHoraInicio || ""}
                      onChange={(e) =>
                        setFormExcecao({ ...formExcecao, dataHoraInicio: e.target.value })
                      }
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Data Hora Final:</label>
                  <div className="data-hora-row">

                    <input
                      type="datetime-local"
                      value={formExcecao.dataHoraFim || ""}
                      onChange={(e) =>
                        setFormExcecao({ ...formExcecao, dataHoraFim: e.target.value })
                      }
                    />                    
                    
                  </div>
                </div>

                <div className="form-actions">
                  <button onClick={() => setModoEdicaoExcecao(false)}>
                    Cancelar
                  </button>

                  <button className="btn-salvar-excecao" onClick={salvarExcecao}>
                    Salvar Exceção
                  </button>
                </div>

              </div>
            )}

          </div>
        )}


      </ModalBody>

      <ModalFooter>
        {activeTab === "excecao" ? (
          <button
            className="btn-fechar-horario"
            onClick={onClose}
          >
            Fechar
          </button>
        ) : (
          <>
            <button
              className="btn-cancelar-horario"
              onClick={onClose}
            >
              Cancelar
            </button>

            <button
              className="btn-salvar-horario"
              onClick={handleSalvar}
            >
              Salvar
            </button>
          </>
        )}
      </ModalFooter>

    </ModalContainer>
  );
};

export default ModalHorarios;
